module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/maimaisuc.88fee078.png";